// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"AssistedBookingStatus__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AssistedBookingStatus/AssistedBookingStatus.scss
 ** module id = 884
 ** module chunks = 1
 **/